import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPadlockClosedFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.563 8.76866H16.2778C17.1855 8.76866 18.0559 9.13188 18.6977 9.77842C19.3395 10.425 19.7 11.3018 19.7 12.2162V18.5525C19.7 19.4668 19.3395 20.3437 18.6977 20.9902C18.0559 21.6368 17.1855 22 16.2778 22H7.72227C6.81464 22 5.94419 21.6368 5.30239 20.9902C4.6606 20.3437 4.30005 19.4668 4.30005 18.5525V12.2162C4.30005 11.3018 4.6606 10.425 5.30239 9.77842C5.94419 9.13188 6.81464 8.76866 7.72227 8.76866H7.43709V6.59671C7.43709 5.37759 7.91782 4.2084 8.77355 3.34635C9.62927 2.4843 10.7899 2 12 2C13.2102 2 14.3708 2.4843 15.2266 3.34635C16.0823 4.2084 16.563 5.37759 16.563 6.59671V8.76866ZM10.3623 4.90972C9.93468 5.36416 9.70322 5.97075 9.71857 6.59671V8.76866H14.2815V6.59671C14.2969 5.97075 14.0654 5.36416 13.6378 4.90972C13.2102 4.45527 12.6213 4.18999 12 4.17195C11.3788 4.18999 10.7899 4.45527 10.3623 4.90972ZM12.0001 13.1429C11.1338 13.1429 10.4315 13.8465 10.4315 14.7144V16.1429C10.4315 17.0108 11.1338 17.7144 12.0001 17.7144C12.8663 17.7144 13.5686 17.0108 13.5686 16.1429V14.7144C13.5686 13.8465 12.8663 13.1429 12.0001 13.1429Z",
		fill: "currentColor"
	})
});
export default SvgIconPadlockClosedFill;
